var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "deals-menu" }, [
    _c(
      "div",
      { staticClass: "extended-block" },
      [
        _c("h6", [_vm._v("Deals")]),
        _vm._v(" "),
        _c("menu-item", {
          attrs: {
            path: "/matching/marketplaces",
            text: "DealRooms",
            caption: "Finance & Invest in African (High-Growth) Companies",
          },
          on: {
            click: function ($event) {
              return _vm.handleItemClick("/matching/marketplaces")
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }